import { RootState } from '@next/core-lib/app';

import { SelectedLocation, Identification } from '@next/core-lib/user';
import {
  DeliveryColumnTypes,
  DeliveryLineWithDelivery,
} from 'src/app/delivery-data/delivery-data.model';
import { CustomerBrsNumber } from 'src/app/shared/models/shared.models';

import { DateRange } from '../../shared/models/date-range.model';

export interface LocationWithBRS extends SelectedLocation {
  brs: Identification[];
}

export interface MineralModuleState extends RootState {
  mineralLegalNoticeVisible: boolean;
}

export const displayColumns = [
  DeliveryColumnTypes.deliveryDate,
  DeliveryColumnTypes.externalInvoiceId,
  DeliveryColumnTypes.allShipToIds,
  DeliveryColumnTypes.externalProductId,
  DeliveryColumnTypes.productTitle,
  DeliveryColumnTypes.productGroupDescription,
  DeliveryColumnTypes.unitQuantity,
  DeliveryColumnTypes.phosphateTotal,
  DeliveryColumnTypes.nitrogenTotal,
] as const;

export type MineralOverviewViewModel = Pick<
  DeliveryLineWithDelivery,
  (typeof displayColumns)[number] | 'id' | 'deliveryId'
>;

export interface MineralOverviewDataFilters {
  brsNumber: CustomerBrsNumber;
  search: string;
  dateRange: DateRange;
}
